import React, { useState } from 'react';

const LazyImage = ({ src, alt, className = '', fallback, onClick, ...props }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  if (error && fallback) return fallback;

  return (
    <div className={`relative ${className}`} onClick={onClick} {...props}>
      {!loaded && !error && (
        <div className="absolute inset-0 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 animate-pulse rounded-inherit" />
      )}
      <img
        src={src}
        alt={alt || ''}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
        style={{ position: loaded ? 'relative' : 'absolute', inset: 0 }}
      />
    </div>
  );
};

export default LazyImage;
